export const reactivateDefaultPlanPerks = [
  {
    label: 'Seasonal Box: 8–10 products valued at $200+',
    check: {
      seasonal: true,
      annual: false,
    },
    skip: {
      seasonal: false,
      annual: true,
    },
    col: '1',
  },
  {
    label: 'The Seasonal Box',
    check: {
      seasonal: false,
      annual: true,
    },
    skip: {
      seasonal: true,
      annual: false,
    },
    col: '1',
  },
  {
    label: 'Customize your box',
    check: {
      seasonal: true,
      annual: true,
    },
    skip: {
      seasonal: false,
      annual: false,
    },
    col: '1',
  },
  {
    label: 'Members Only Sales',
    check: {
      seasonal: true,
      annual: true,
    },
    skip: {
      seasonal: false,
      annual: false,
    },
    col: '1',
  },
  {
    label: 'FabFitFun TV',
    check: {
      seasonal: true,
      annual: true,
    },
    skip: {
      seasonal: false,
      annual: false,
    },
    col: '1',
  },
  {
    label: 'The Community Forum',
    check: {
      seasonal: true,
      annual: true,
    },
    skip: {
      seasonal: false,
      annual: false,
    },
    col: '2',
  },
  {
    label: 'More box customization options each season',
    check: {
      seasonal: false,
      annual: true,
    },
    skip: {
      seasonal: false,
      annual: false,
    },
    col: '2',
  },
  {
    label: "Early access to member's only sales",
    check: {
      seasonal: false,
      annual: true,
    },
    skip: {
      seasonal: false,
      annual: false,
    },
    col: '2',
  },
  {
    label: 'Earlier shipping with our first billing/shipping date',
    check: {
      seasonal: false,
      annual: true,
    },
    skip: {
      seasonal: false,
      annual: false,
    },
    col: '2',
  },
];

export const reactivateDefaultAdditionalPlanPerks = [
  {
    label: 'Seasonal Box: 8–10 products valued at $200+',
    check: {
      seasonal: true,
      annual: false,
    },
    skip: {
      seasonal: false,
      annual: true,
    },
    col: '1',
  },
  {
    label: 'The Seasonal Box',
    check: {
      seasonal: false,
      annual: true,
    },
    skip: {
      seasonal: true,
      annual: false,
    },
    col: '1',
  },
  {
    label: 'Customize some of your box',
    check: {
      seasonal: true,
      annual: false,
    },
    skip: {
      seasonal: false,
      annual: true,
    },
    col: '1',
  },
  {
    label: 'Customize your ENTIRE box',
    check: {
      seasonal: false,
      annual: true,
    },
    skip: {
      seasonal: true,
      annual: false,
    },
    col: '1',
  },
  {
    label: 'Members Only Sales',
    check: {
      seasonal: true,
      annual: true,
    },
    skip: {
      seasonal: false,
      annual: false,
    },
    col: '1',
  },
  {
    label: 'FabFitFun TV',
    check: {
      seasonal: true,
      annual: true,
    },
    skip: {
      seasonal: false,
      annual: false,
    },
    col: '1',
  },
  {
    label: 'The Community Forum',
    check: {
      seasonal: true,
      annual: true,
    },
    skip: {
      seasonal: false,
      annual: false,
    },
    col: '2',
  },
  {
    label: 'Unlimited Swap for Credit',
    check: {
      seasonal: true,
      annual: true,
    },
    skip: {
      seasonal: false,
      annual: false,
    },
    col: '2',
  },
  {
    label: 'More box customization options each season',
    check: {
      seasonal: false,
      annual: true,
    },
    skip: {
      seasonal: false,
      annual: false,
    },
    col: '2',
  },
  {
    label: "Early access to member's only sales",
    check: {
      seasonal: false,
      annual: true,
    },
    skip: {
      seasonal: false,
      annual: false,
    },
    col: '2',
  },
  {
    label: 'Earlier shipping with our first billing/shipping date',
    check: {
      seasonal: false,
      annual: true,
    },
    skip: {
      seasonal: false,
      annual: false,
    },
    col: '2',
  },
];
